export const BillingAdminControllerFactory = ({
  billingAdminService,
}: {
  billingAdminService: IBillingAdminService;
}) => {
  /**
   * Payers
   */
  const getPayers: IGetBillingAdminPayers = async (payload) => {
    const response = await billingAdminService.getPayers(payload);
    return response;
  };

  const updatePayer: IUpdateBillingAdminPayer = async (payload) => {
    const response = await billingAdminService.updatePayer(payload);
    return response;
  };

  const createPayer: ICreateBillingAdminPayer = async (payload) => {
    const response = await billingAdminService.createPayer(payload);
    return response;
  };

  const deletePayer: IDeleteBillingAdminPayer = async (id) => {
    const response = await billingAdminService.deletePayer(id);
    return response;
  };

  /**
   * Providers
   */
  const getProviders: IGetBillingAdminProviders = async (payload) => {
    const response = await billingAdminService.getProviders(payload);
    return response;
  };

  const updateProvider: IUpdateBillingAdminProvider = async (payload) => {
    const response = await billingAdminService.updateProvider(payload);
    return response;
  };

  const createProvider: ICreateBillingAdminProvider = async (payload) => {
    const response = await billingAdminService.createProvider(payload);
    return response;
  };

  const deleteProvider: IDeleteBillingAdminProvider = async (id) => {
    const response = await billingAdminService.deleteProvider(id);
    return response;
  };

  /**
   * Entity
   */
  const getEntities: IGetBillingAdminEntity = async (payload) => {
    const response = await billingAdminService.getEntities(payload);
    return response;
  };

  const updateEntity: IUpdateBillingAdminEntity = async (payload) => {
    const response = await billingAdminService.updateEntity(payload);
    return response;
  };

  const createEntity: ICreateBillingAdminEntity = async (payload) => {
    const response = await billingAdminService.createEntity(payload);
    return response;
  };

  const deleteEntity: IDeleteBillingAdminEntity = async (id) => {
    const response = await billingAdminService.deleteEntity(id);
    return response;
  };

  /**
   * Clinics
   */
  const getClinics: IGetBillingAdminClinics = async (payload) => {
    const response = await billingAdminService.getClinics(payload);
    return response;
  };

  const updateClinic: IUpdateBillingAdminClinic = async (payload) => {
    const response = await billingAdminService.updateClinic(payload);
    return response;
  };

  /**
   * Rosters
   */
  const getRosters: IGetBillingAdminRoster = async (payload) => {
    const response = await billingAdminService.getRosters(payload);
    return response;
  };

  const updateRoster: IUpdateBillingAdminRoster = async (payload) => {
    const response = await billingAdminService.updateRoster(payload);
    return response;
  };

  const createRoster: ICreateBillingAdminRoster = async (payload) => {
    const response = await billingAdminService.createRoster(payload);
    return response;
  };

  const deleteRoster: IDeleteBillingAdminRoster = async (id) => {
    const response = await billingAdminService.deleteRoster(id);
    return response;
  };

  /**
   * Patients
   */
  const getPatients: IGetBillingAdminPatients = async (payload) => {
    const response = await billingAdminService.getPatients(payload);
    return response;
  };

  const updatePatient: IUpdateBillingAdminPatient = async (payload) => {
    const response = await billingAdminService.updatePatient(payload);
    return response;
  };

  const createPatient: ICreateBillingAdminPatient = async (payload) => {
    const response = await billingAdminService.createPatient(payload);
    return response;
  };

  const deletePatient: IDeleteBillingAdminPatient = async (id) => {
    const response = await billingAdminService.deletePatient(id);
    return response;
  };

  /**
   * Charges
   */
  const getCharges: IGetBillingAdminCharges = async (payload) => {
    const response = await billingAdminService.getCharges(payload);
    return response;
  };

  const updateCharges: IUpdateBillingAdminCharges = async (payload) => {
    const response = await billingAdminService.updateCharges(payload);
    return response;
  };

  const createCharges: ICreateBillingAdminCharges = async (payload) => {
    const response = await billingAdminService.createCharges(payload);
    return response;
  };

  const deleteCharges: IDeleteBillingAdminCharges = async (id) => {
    const response = await billingAdminService.deleteCharges(id);
    return response;
  };

  const getChargesStatusSummary = async (payload: any) => {
    const response = await billingAdminService.getChargesStatusSummary(payload);
    return response;
  };

  const checkPatientEligibility: ICheckPatientEligibility = async (payload) => {
    return billingAdminService.checkPatientEligibility(payload);
  };

  const refreshEligibility: IRefreshEligibilityController = async (payload) => {
    return billingAdminService.refreshEligibility(payload);
  };

  return {
    getPayers,
    updatePayer,
    createPayer,
    deletePayer,

    getProviders,
    updateProvider,
    createProvider,
    deleteProvider,

    getEntities,
    updateEntity,
    createEntity,
    deleteEntity,

    getClinics,
    updateClinic,

    getRosters,
    updateRoster,
    createRoster,
    deleteRoster,

    getPatients,
    updatePatient,
    createPatient,
    deletePatient,

    getCharges,
    updateCharges,
    createCharges,
    deleteCharges,
    getChargesStatusSummary,
    checkPatientEligibility,
    refreshEligibility,
  };
};
